import type { Column } from '../../model/types';

export function columnTypeText(column: Column): string {
  if (column.kind === 'multi')
    return 'Multiple choice: a person can have more than one';
  if (column.kind === 'number') return 'Number';
  return 'Single choice';
}

export const MULTI_CHOICE_NOTE =
  'Not offered for this column. People can have more than one value in a multiple-choice column, so it isn\'t clear what "the same" means.';
